export default {
  name: "workgroup_comments",
  data: () => ({
    workgroup_comments: [],
  }),
  methods: {
    async workgroup_comments_get() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_comments_get")
      );
      if (result instanceof Array) this.workgroup_comments = result;
      else {
        this.workgroup_comments = [];
      }
    },
    async workgroup_comments_get_own() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_comments_get_own")
      );
      if (result instanceof Array) this.workgroup_comments = result;
      else {
        this.workgroup_comments = [];
      }
    },
    async workgroup_comments_create() {
      return this.$communicator.then(
        this,
        await this.$communicator("workgroup_comments_create", {
          params: {
            workgroup_comments: this.workgroup_comments,
          },
        })
      );
    },
  },
};
